import {
  List,
  DatagridConfigurable,
  TextField,
  NumberField,
  TopToolbar,
  SelectColumnsButton,
  useDefaultTitle,
  useListContext,
  FunctionField,
  FilterButton,
  ExportButton,
  DateInput,
} from "react-admin";
import LikeShow from "./LikeShow";
import { Timestamp } from "firebase/firestore";

const listFilters = [
  <DateInput source="time_gte" alwaysOn />,
  <DateInput source="time_lte" alwaysOn />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <SelectColumnsButton />
    <ExportButton />
  </TopToolbar>
);

const UserActionsTitle = () => {
  const title = useDefaultTitle();
  const { defaultTitle } = useListContext();
  return (
    <>
      <title>{`${title} - ${defaultTitle}`}</title>
      <span>{defaultTitle}</span>
    </>
  );
};

// Custom time formatting field
const FormattedTimeField = ({ record }: { record?: any }) => {
  if (!record?.time) return null;
  const date =
    record.time instanceof Timestamp
      ? record.time.toDate()
      : new Date(record.time);
  return <span>{date.toLocaleString()}</span>;
};

const LikeList = () => (
  <List
    resource="userActions"
    perPage={25}
    queryOptions={{ meta: { type_eq: "like" } }}
    sort={{ field: "time", order: "DESC" }}
    actions={<ListActions />}
    filters={listFilters}
    title={<UserActionsTitle />}
  >
    <DatagridConfigurable
      rowClick="expand"
      bulkActionButtons={false}
      expand={<LikeShow />}
      sx={{
        "& .column-referenceId": {
          display: { xs: "none", md: "table-cell" },
        },
        "& .column-referenceType": {
          display: { xs: "none", md: "table-cell" },
        },
        "& .column-userId": {
          display: { xs: "none", md: "table-cell" },
        },
        "& .column-count": {
          display: { xs: "none", md: "table-cell" },
        },
      }}
    >
      <TextField source="userName" sortable={false} />
      <TextField source="social" sortable={false} />
      <TextField source="email" sortable={false} />
      <FunctionField
        label="Time"
        render={(record) => <FormattedTimeField record={record} />}
      />
      <TextField source="referenceType" sortable={false} />
      <NumberField source="count" sortable={false} />
    </DatagridConfigurable>
  </List>
);

export default LikeList;
